export class ApiError {}
